{
  "button": "Proceed",
  "cards": {
    "get_help": {
      "body": "The Help menu includes page-level help, access to the Bigleaf Help Center, and feedback options",
      "title": "Get help or provide feedback"
    },
    "multi_site": {
      "body": "See information about all of your sites including current status and alerts – know that all is well, or if there’s an issue to investigate and resolve",
      "title": "Multi-site information"
    },
    "streamlined": {
      "body": "Global search function on every page with helpful filters to quickly find the information that’s most important to you",
      "title": "Streamlined navigation"
    }
  },
  "main": {
    "WDB_v1_toggle": {
      "text": "If you want to revert to the legacy Web Dashboard, you can do so until the end of the 2024. Simply click on your user profile in the top navigation bar and turn off the ‘Bigleaf new look’ toggle."
    },
    "get_started": {
      "link_text": "Getting Started with Bigleaf Cloud Connect",
      "text": "For an overview of new features and improvements, see"
    },
    "p1": {
      "content": "Bigleaf Cloud Connect helps monitor your internet connectivity and reliability.<br><span>{{highlighted}}</span>",
      "highlighted": "Quickly see the current status of all sites that use Bigleaf and get actionable information about how to manage your internet connection."
    },
    "p2": {
      "content": "You’ll see alerts, circuit and device status, and overall internet circuit performance data. And if you need assistance, the <span>{{highlighted}}</span> to Bigleaf about your experience using Cloud Connect.",
      "highlighted": "Help menu offers several ways to get the help you need and to provide feedback"
    }
  },
  "title": "Welcome to Bigleaf Cloud Connect"
}
